import { FloatingNotification } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { StatusWarning as StatusWarningIcon } from '@wix/wix-ui-icons-common';
import { useRouter } from 'next/router';
import React, { FunctionComponent, useEffect, useState } from 'react';

import { DATA_HOOKS } from '../../dataHooks';

export const ArticlePreviewNotification: FunctionComponent = () => {
  const {
    query: { preview },
  } = useRouter();
  const { t } = useTranslation();
  const [isDisplay, setIsDisplay] = useState(preview === 'true');

  useEffect(() => {
    const bodyElm = document.body;
    if (isDisplay) {
      bodyElm.classList.add('preview');
    } else {
      bodyElm.classList.remove('preview');
    }
  }, [isDisplay]);

  return isDisplay ? (
    <FloatingNotification
      prefixIcon={<StatusWarningIcon />}
      dataHook={DATA_HOOKS.ARTICLE_PREVIEW_NOTIFICATION}
      type="warning"
      fullWidth
      onClose={() => {
        setIsDisplay(false);
      }}
      text={t('article.preview-notification')}
    />
  ) : null;
};
